import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ResourcesProvider, EmpresaDataProvider } from "app/contexts";
import { App } from "./app";
import { Toaster } from "react-hot-toast";
import { MemoryRouter as Router } from "react-router-dom";

import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootswatch/dist/cosmo/bootstrap.min.css";
import "animate.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // refetchInterval: 1000,
    },
  },
});

root.render(
  <React.StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <ResourcesProvider>
          <EmpresaDataProvider>
            <App />
            <Toaster />
          </EmpresaDataProvider>
        </ResourcesProvider>
      </QueryClientProvider>
    </Router>
  </React.StrictMode>
);
